import { render, staticRenderFns } from "./OfficeRectificationView.vue?vue&type=template&id=7638a367&scoped=true"
import script from "./OfficeRectificationView.vue?vue&type=script&lang=js"
export * from "./OfficeRectificationView.vue?vue&type=script&lang=js"
import style0 from "./OfficeRectificationView.vue?vue&type=style&index=0&id=7638a367&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7638a367",
  null
  
)

export default component.exports